import { FaChevronLeft } from "react-icons/fa6";
import { useConfig } from "../context/config-context";
import { useAlert } from "../context/alert-context";
import AlertBanner from "./AlertBanner";

const BackgroundSection = ({ siteConfig }) => (
  <div className="absolute z-0 flex flex-row justify-between w-screen h-screen">
    <div className="w-0 md:w-0 lg:w-[60%] h-[67.5%] lg:pl-5">
      <div className="w-full h-full bg-secondary"></div>
    </div>
    <div className="w-full lg:w-[40%] h-screen flex flex-col justify-end">
      <div className="w-[35%] h-[35%] lg:h-[25%] bg-primary flex justify-center p-2 ml-auto relative ">
        <div className="absolute -top-36 -left-36 w-36 h-36 bg-dark"></div>
        <img
          src={siteConfig.medias.auth.group.path}
          alt={siteConfig.medias.auth.group.alt}
        />
      </div>
      <div className="w-[65%] h-[40%] bg-light flex items-end">
        <img
          src={siteConfig.medias.auth.perso.path}
          alt={siteConfig.medias.auth.perso.alt}
          className="mx-auto"
        />
      </div>
    </div>
  </div>
);

const Logo = ({ siteConfig }) => (
  <div className="absolute invisible lg:visible top-3 left-3 md:left-20">
    <img
      src={siteConfig.medias.logo.path}
      alt={siteConfig.medias.logo.alt}
      className="w-[130px] h-[56px] lg:w-[230px] lg:h-[126px]"
    />
  </div>
);

const Card = ({ className, children, siteConfig, alert, hideAlert }) => (
  <div
    className={`flex flex-col gap-4 bg-white rounded-lg shadow-xl p-10 max-w-[590px] mt-7 ${className}`}
  >
    <span className="flex flex-col justify-center gap-0 text-2xl font-bold text-center text-primary">
      <span>{siteConfig.welcome}</span>
    </span>
    {alert && (
      <AlertBanner
        type={alert.type}
        message={alert.message}
        onClose={hideAlert}
      />
    )}
    {children}
  </div>
);

const BackToLogin = ({ siteConfig }) => (
  <a
    href={siteConfig.routes.login.path}
    className="flex flex-row items-center space-x-1 text-sm text-blue-800 underline w-fit"
  >
    <FaChevronLeft />
    <span className="underline">{siteConfig.components.back_button}</span>
  </a>
);

function AuthGabarit({ children, className, DisplayLoginButton }) {
  const siteConfig = useConfig();
  const { alert, hideAlert } = useAlert();

  return (
    <div className="relative bg-white">
      <BackgroundSection siteConfig={siteConfig} />
      <section className="relative flex items-center justify-center w-screen h-screen px-2 pt-5">
        <Logo siteConfig={siteConfig} />
        <Card className={className} siteConfig={siteConfig} alert={alert} hideAlert={hideAlert}>
          {children}
          {DisplayLoginButton ? <BackToLogin siteConfig={siteConfig} /> : null}
        </Card>
      </section>
    </div>
  );
}

export default AuthGabarit;
